var Styles = {"surveyBox":"AidQuestionnaire-module_surveyBox__K6-Y9","desc":"AidQuestionnaire-module_desc__WjUfc","options":"AidQuestionnaire-module_options__K-wbF","option":"AidQuestionnaire-module_option__cLdPv","active":"AidQuestionnaire-module_active__R19R6","inputer":"AidQuestionnaire-module_inputer__Vpb84"};

export { Styles as default };
